import { render, staticRenderFns } from "./VeltrixSettings.vue?vue&type=template&id=443ebbf0&scoped=true"
import script from "./VeltrixSettings.vue?vue&type=script&lang=js"
export * from "./VeltrixSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443ebbf0",
  null
  
)

export default component.exports